import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { EnviarEmailComponent } from './enviar-email/enviar-email.component';
import { UploadComponent } from './upload/upload.component';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';

@Component({
  selector: 'app-vigencia-derecho',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, EnviarEmailComponent, UploadComponent],
  templateUrl: './vigencia-derecho.component.html',
  styleUrl: './vigencia-derecho.component.scss',
})
export class VigenciaDerechoPage {}
